@if (block) {
  <section class="feature-highlight block-container" [style.color]="block.textColor">
    <div class="content">
      <div class="content-header" [class.no-description]="!block.text">
        <div class="wrapper">
          <div class="title" [rtl]="block.langcode">
            <h1 [innerHtml]="block.title"></h1>
            @if (block.subTitle) {
              <div class="subtitle" [class.primary-color]="!block.textColor" [innerHtml]="block.subTitle"></div>
            }
          </div>
          @if (block.text) {
            <p class="ck-text" [innerHtml]="block.text | safeHtml" [rtl]="block.langcode"></p>
          }
        </div>
      </div>
      @if (block.sliderEnabled) {
        <lib-swiper [slides]="block.items" [options]="swiperOptions">
          <ng-template swiperContent let-item="item">
            <div class="item">
              @if (item.mediaImage) {
                <div class="image">
                  <img [cropImage]="item.mediaImage | preSignedUrl | async" [additionalOptions]="{width: 300, height: 300, func: 'bound'}" [attr.alt]="item.mediaImage.alt">
                </div>
              }
              <div class="item-text ck-text" [innerHtml]="item.text | safeHtml" [rtl]="item.langcode"></div>
            </div>
          </ng-template>
        </lib-swiper>
        @if (!swiperComponent?.swiper?.isBeginning || !swiperComponent?.swiper?.isEnd) {
          <div class="d-none d-lg-flex carousel-buttons-wrapper">
            <button color="primary" mat-fab class="carousel-button left" [style.color]="block.textColor" [style.border-color]="block.textColor" [class.disabled]="swiperComponent?.swiper?.isBeginning" (click)="swiperComponent?.swiper?.slidePrev()">
              <mat-icon>navigate_before</mat-icon>
            </button>
            <button color="primary" mat-fab class="carousel-button right" [style.color]="block.textColor" [style.border-color]="block.textColor" [class.disabled]="swiperComponent?.swiper?.isEnd" (click)="swiperComponent?.swiper?.slideNext()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
        }
      } @else {
        <div class="item-list">
          @for (item of block.items; track item) {
            <div class="item">
              @if (item.mediaImage) {
                <div class="image">
                  <img [cropImage]="item.mediaImage | preSignedUrl | async" [additionalOptions]="{width: 300, height: 300, func: 'bound'}" [attr.alt]="item.mediaImage.alt">
                </div>
              }
              <div class="item-text ck-text" [innerHtml]="item.text | safeHtml" [rtl]="block.langcode"></div>
            </div>
          }
        </div>
      }
    </div>
  </section>
}
